<template>
  <div id="profileOne"></div>
</template>

<script>
export default {
  name: "ProfileOne",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        name: "Jane Smith",
        title: "Product Designer",
        bio: "Passionate about creating intuitive user experiences that drive business growth.",
        chip: "Meet the Team",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    isDarkColor(color) {
      let r, g, b;
      if (color.startsWith("#")) {
        const hex = color.slice(1);
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
      } else {
        const rgb = color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return false;
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      }
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128;
    },
    getInitials(name) {
      return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    },
    render() {
      const el = document.getElementById("profileOne");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const nameSize = exporting ? 72 : 72 * this.scale;
      const titleSize = exporting ? 36 : 36 * this.scale;
      const bioSize = exporting ? 28 : 28 * this.scale;
      const logoHeight = exporting ? 50 : 50 * this.scale;
      const chipSize = exporting ? 22 : 22 * this.scale;
      const avatarSize = exporting ? 180 : 180 * this.scale;
      const initialsSize = exporting ? 64 : 64 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#000000";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
          "
        >
          <div style="padding: 10%">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <div style="padding: 0 10%; text-align: center;">
            <!-- Avatar/Initials -->
            <div style="
              width: ${avatarSize}px;
              height: ${avatarSize}px;
              background: ${primaryColor};
              border-radius: 50%;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 32px;
            ">
              <span style="
                font-size: ${initialsSize}px;
                font-weight: 700;
                color: ${this.isDarkColor(primaryColor) ? "#fff" : "#000"};
              ">${this.getInitials(this.data.name)}</span>
            </div>

            <!-- Name -->
            <div style="
              font-size: ${nameSize}px;
              font-weight: 700;
              color: #272727;
              margin-bottom: 12px;
              line-height: 1.1;
            ">${this.data.name}</div>

            <!-- Title -->
            <div style="
              font-size: ${titleSize}px;
              font-weight: 500;
              color: ${primaryColor};
              margin-bottom: 24px;
            ">${this.data.title}</div>

            <!-- Bio -->
            <div style="
              font-size: ${bioSize}px;
              font-weight: 400;
              color: #737373;
              line-height: 1.5;
              max-width: 80%;
              margin: 0 auto;
            ">${this.data.bio}</div>
          </div>

          <div style="padding: 10%">
            <div style="display: flex; justify-content: center;">
              <span
                style="
                  display: inline-block;
                  background: ${primaryColor};
                  color: ${this.isDarkColor(primaryColor) ? "#fff" : "#000"};
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 7px 22px;
                  letter-spacing: 0.03em;
                  font-family: 'Inter', Arial, sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
